import React from 'react';

const row1Items = [
  { icon: '/icons/image-wtkwS4EB839o6gNHQPsxRuMr1x33T9.png.avif', label: 'Choosing a block of land', alt: 'BuildPilot App helps with choosing a block of land in Australia' },
  { icon: '/icons/image-6F0Oea8suMLdEi6BoluXYbqXxnWEdt-min.png.avif', label: 'Building a new home', alt: 'BuildPilot App guides you through building a new home' },
  { icon: '/icons/image-mxg7b0UfPQISIHqmg5ckgLxvhhqNM6.png.avif', label: 'Renovations', alt: 'BuildPilot App supports home renovations and upgrades' },
  { icon: '/icons/image-X4EofF15e7UUioIAr6nUli2CROWWLy-min.png.avif', label: 'Changing builders', alt: 'BuildPilot App assists when changing builders mid-project' },
];

const row2Items = [
  { icon: '/icons/image-igeoKPShP33E35sBtTGol79NGhHQlK.png.avif', label: 'Invest or develop', alt: 'BuildPilot App for property investment and development projects' },
  { icon: '/icons/image-3NUBakWR24XMZoWGz2qC7Lbgsl4iqY-min.png.avif', label: 'Verandahs or pergolas', alt: 'BuildPilot App helps plan verandahs and pergola construction' },
  { icon: '/icons/image-WLDPojfK8ZW60BIjedFZCTRIcdTwKN-min.png.avif', label: 'Landscaping', alt: 'BuildPilot App supports landscaping and outdoor projects' },
  { icon: '/icons/image-il4n6aTTlaIJKQnA8WgM4lI6WqMNZj-min.png.avif', label: 'Sheds or garages', alt: 'BuildPilot App for building sheds and garages' },
];

const row3Items = [
  { icon: '/icons/image-YU8VPh1mskoIZQ7wSPeUKvvcXSrssY-min.png.avif', label: 'Decking', alt: 'BuildPilot App helps with decking and outdoor living projects' },
  { icon: '/icons/image-2lorEIIaeeDsHDW0gQw4MbmuyVqwXH.png.avif', label: 'Interior design', alt: 'BuildPilot App supports interior design planning' },
  { icon: '/icons/image-HRxzMB9JoMV1VSElMnT1GVJvnayzbM.png.avif', label: 'Home design', alt: 'BuildPilot App for home design and floor plans' },
  { icon: '/icons/image-BWBtiIA0RTZ9SrIb0oOdPBZRfvTVYn-min.png.avif', label: 'Swimming pools', alt: 'BuildPilot App helps plan swimming pool construction' },
];

const MarqueeRow = ({ items, direction = 'left', speed = 30 }) => {
  const duplicatedItems = [...items, ...items, ...items, ...items];
  
  return (
    <div className="relative overflow-hidden py-3">
      <div 
        className={`flex gap-4 ${direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'}`}
        style={{ 
          width: 'max-content',
          animationDuration: `${speed}s`
        }}
      >
        {duplicatedItems.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-3 px-5 py-3 rounded-full border border-purple-200/60 bg-gradient-to-r from-purple-50 to-pink-50"
            style={{
              boxShadow: '0 2px 8px rgba(139, 92, 246, 0.1)'
            }}
          >
            <img 
              src={item.icon} 
              alt={item.alt}
              className="w-9 h-9 object-contain"
            />
            <span className="text-gray-700 font-medium whitespace-nowrap">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const ScrollingFeaturesSection = () => {
  return (
    <section id="who-its-for" className="py-16 bg-white overflow-hidden" data-testid="scrolling-features">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <h2 className="font-serif text-4xl sm:text-5xl text-gray-900 text-center">
          Built for <span className="gradient-text">you</span>.
        </h2>
      </div>
      
      <div className="space-y-2">
        <MarqueeRow items={row1Items} direction="left" speed={25} />
        <MarqueeRow items={row2Items} direction="right" speed={28} />
        <MarqueeRow items={row3Items} direction="left" speed={22} />
      </div>
    </section>
  );
};

export default ScrollingFeaturesSection;
